(function() {

  function adicionarListener(atcBtn) {
    if (!atcBtn || atcBtn.dataset.cloned) return;

    var clone = atcBtn.cloneNode(true);
    clone.dataset.cloned = 'true';
    atcBtn.parentNode.replaceChild(clone, atcBtn);

    clone.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var form = clone.closest('form');
      var variantId = form.querySelector('[name="id"]').value;
      var qty = form.querySelector('[name="quantity"]');
      var quantity = qty ? qty.value : 1;

      clone.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
      })
      .then(function(r) { return r.json(); })
      .then(function() { return fetch('/?sections=cart'); })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data['cart'], 'text/html');

        var newItems = doc.querySelector('.cart__items');
        var currentItems = document.querySelector('.cart__items');
        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

        var newTotal = doc.querySelector('.cart__total');
        var currentTotal = document.querySelector('.cart__total');
        if (newTotal && currentTotal) currentTotal.innerHTML = newTotal.innerHTML;

        var emptyMsg = document.querySelector('.cart__empty');
        if (emptyMsg) emptyMsg.classList.add('hidden');

        var cartToggle = document.querySelector('[data-cart-drawer-toggle]');
        if (cartToggle) cartToggle.click();

        clone.disabled = false;
      })
      .catch(function(err) {
        console.error('Erro:', err);
        clone.disabled = false;
      });

    }, true);
  }

  // Tenta imediatamente
  var btn = document.querySelector('[data-add-to-cart]');
  if (btn) adicionarListener(btn);

  // MutationObserver para detectar quando a Yampi inicializa
  var observer = new MutationObserver(function() {
    var btn = document.querySelector('[data-add-to-cart]:not([data-cloned])');
    if (btn) adicionarListener(btn);
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true });

})();
